import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import PageNavigation from "@/components/PageNavigation";
import SEOHead from "@/components/seo/SEOHead";

export default function LGPD() {
  return (
    <>
      <SEOHead
        title="LGPD - Lei Geral de Proteção de Dados"
        description="Informações sobre conformidade com a LGPD no Vendas Trainer. Conheça seus direitos e como tratamos seus dados pessoais."
        keywords="LGPD, proteção de dados, direitos do titular, DPO, conformidade"
        canonicalUrl="https://bianchimbusiness.com.br/lgpd"
      />

      <Header />

      <main id="main-content" className="min-h-screen bg-background pt-20" role="main" aria-labelledby="page-title">
        <article className="container mx-auto px-4 py-16 max-w-4xl">
          <header>
            <h1 id="page-title" className="text-4xl font-bold text-foreground mb-8">LGPD - Lei Geral de Proteção de Dados</h1>
          </header>
          
          <div className="prose prose-lg dark:prose-invert max-w-none space-y-6 text-muted-foreground">
            <p className="text-lg">A Bianchim Business está comprometida com a proteção dos dados pessoais de seus usuários em conformidade com a Lei nº 13.709/2018 (Lei Geral de Proteção de Dados Pessoais - LGPD).</p>

            <section className="space-y-4" aria-labelledby="what-section">
              <h2 id="what-section" className="text-2xl font-semibold text-foreground">O que é a LGPD?</h2>
              <p>A Lei Geral de Proteção de Dados (LGPD) é a legislação brasileira que regula o tratamento de dados pessoais por empresas e organizações. Ela garante direitos fundamentais aos titulares de dados e estabelece regras claras sobre coleta, armazenamento e uso de informações pessoais.</p>
            </section>

            <section className="space-y-4" aria-labelledby="rights-section">
              <h2 id="rights-section" className="text-2xl font-semibold text-foreground">Seus Direitos como Titular</h2>
              <p>A LGPD garante os seguintes direitos:</p>
              <ul className="list-disc pl-6 space-y-2" role="list">
                <li><strong>Confirmação e Acesso:</strong> Saber se tratamos seus dados e acessar uma cópia</li>
                <li><strong>Correção:</strong> Solicitar a correção de dados incompletos ou desatualizados</li>
                <li><strong>Anonimização ou Bloqueio:</strong> Solicitar tratamento restrito de dados desnecessários</li>
                <li><strong>Portabilidade:</strong> Receber seus dados em formato estruturado</li>
                <li><strong>Eliminação:</strong> Solicitar a exclusão de dados tratados com base no consentimento</li>
                <li><strong>Informação:</strong> Saber com quem compartilhamos seus dados</li>
                <li><strong>Revogação:</strong> Retirar seu consentimento a qualquer momento</li>
                <li><strong>Oposição:</strong> Se opor ao tratamento em certas situações</li>
              </ul>
            </section>

            <section className="space-y-4" aria-labelledby="legal-section">
              <h2 id="legal-section" className="text-2xl font-semibold text-foreground">Base Legal para Tratamento</h2>
              <p>Tratamos seus dados com base nas seguintes hipóteses legais:</p>
              <ul className="list-disc pl-6 space-y-2" role="list">
                <li><strong>Consentimento:</strong> Quando você autoriza expressamente</li>
                <li><strong>Execução de Contrato:</strong> Para fornecer os serviços contratados</li>
                <li><strong>Legítimo Interesse:</strong> Para melhorar nossos serviços</li>
                <li><strong>Cumprimento Legal:</strong> Para atender obrigações legais</li>
              </ul>
            </section>

            <section className="space-y-4" aria-labelledby="dpo-section">
              <h2 id="dpo-section" className="text-2xl font-semibold text-foreground">Encarregado de Dados (DPO)</h2>
              <p>Nosso Encarregado pelo Tratamento de Dados Pessoais está disponível para esclarecer dúvidas e receber solicitações relacionadas à LGPD:</p>
              <address className="not-italic space-y-2">
                <p><strong>Nome:</strong> Junior Bianchim</p>
                <p><strong>E-mail:</strong> <a href="mailto:junior@bianchimbusiness.com.br" className="text-primary hover:underline">junior@bianchimbusiness.com.br</a></p>
                <p><strong>Telefone:</strong> <a href="tel:+5516981960018" className="text-primary hover:underline">+55 (16) 98196-0018</a></p>
              </address>
            </section>

            <section className="space-y-4" aria-labelledby="exercise-section">
              <h2 id="exercise-section" className="text-2xl font-semibold text-foreground">Como Exercer seus Direitos</h2>
              <p>Para exercer qualquer dos seus direitos previstos na LGPD, entre em contato conosco através dos canais acima. Responderemos sua solicitação em até 15 dias úteis, conforme previsto na legislação.</p>
            </section>

            <section className="space-y-4" aria-labelledby="security-section">
              <h2 id="security-section" className="text-2xl font-semibold text-foreground">Medidas de Segurança</h2>
              <p>Implementamos medidas técnicas e administrativas para proteger seus dados:</p>
              <ul className="list-disc pl-6 space-y-2" role="list">
                <li>Criptografia de dados em trânsito e em repouso</li>
                <li>Controle de acesso baseado em funções</li>
                <li>Monitoramento contínuo de segurança</li>
                <li>Treinamento de colaboradores</li>
                <li>Políticas de backup e recuperação</li>
              </ul>
            </section>

            <section className="space-y-4" aria-labelledby="contact-section">
              <h2 id="contact-section" className="text-2xl font-semibold text-foreground">Contato</h2>
              <address className="not-italic space-y-2">
                <p><strong>E-mail:</strong> <a href="mailto:junior@bianchimbusiness.com.br" className="text-primary hover:underline">junior@bianchimbusiness.com.br</a></p>
                <p><strong>Telefone:</strong> <a href="tel:+5516981960018" className="text-primary hover:underline">+55 (16) 98196-0018</a></p>
                <p><strong>Endereço:</strong> Rua Danilo Micalli, 50 - Santa Felícia, São Carlos – SP – CEP: 13563-264</p>
              </address>
            </section>
          </div>
        </article>
      </main>

      <PageNavigation />
      <Footer />
    </>
  );
}
